// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__qP7tO","footer__help-button":"footer_footer__help-button__17uSK","footer__links":"footer_footer__links__3WAm5"};